import React from 'react'

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

const TimeAgo = ({ date, title }) => <span title={title}>{dayjs().to(dayjs(new Date(date)))}</span>

export default TimeAgo
